"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upperCaseFirst = void 0;

var upperCaseFirst = function upperCaseFirst(str) {
  var firstChar = str.charAt(0);
  return "".concat(firstChar.toUpperCase()).concat(str.slice(1));
};

exports.upperCaseFirst = upperCaseFirst;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wdXJlLWZ1bmN0aW9ucy9zdHJpbmcudHMiXSwibmFtZXMiOlsidXBwZXJDYXNlRmlyc3QiLCJzdHIiLCJmaXJzdENoYXIiLCJjaGFyQXQiLCJ0b1VwcGVyQ2FzZSIsInNsaWNlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQ08sSUFBTUEsY0FBYyxHQUFHLFNBQWpCQSxjQUFpQixDQUFBQyxHQUFHLEVBQUk7QUFDbkMsTUFBTUMsU0FBUyxHQUFHRCxHQUFHLENBQUNFLE1BQUosQ0FBVyxDQUFYLENBQWxCO0FBQ0EsbUJBQVVELFNBQVMsQ0FBQ0UsV0FBVixFQUFWLFNBQW9DSCxHQUFHLENBQUNJLEtBQUosQ0FBVSxDQUFWLENBQXBDO0FBQ0QsQ0FITSIsInNvdXJjZXNDb250ZW50IjpbIlxuZXhwb3J0IGNvbnN0IHVwcGVyQ2FzZUZpcnN0ID0gc3RyID0+IHtcbiAgY29uc3QgZmlyc3RDaGFyID0gc3RyLmNoYXJBdCgwKTtcbiAgcmV0dXJuIGAke2ZpcnN0Q2hhci50b1VwcGVyQ2FzZSgpfSR7c3RyLnNsaWNlKDEpfWBcbn1cbiJdfQ==